// URL do sistema de licitações construído no Lovable.
// Preencher com o endereço definitivo do app (ex.: https://licitacoes.homeofficepremium.com)
export const LOVABLE_LICITACOES_URL = 'https://bid-compass-aid.lovable.app';

export interface CommandModule {
  to: string;
  label: string;
  icon: string;
  end?: boolean;
}

export const COMMAND_MODULES: CommandModule[] = [
  { to: '/painel', label: 'Visão Geral', icon: 'ri-dashboard-3-line', end: true },
  { to: '/painel/crm', label: 'CRM', icon: 'ri-customer-service-2-line' },
  { to: '/painel/oportunidades', label: 'Oportunidades', icon: 'ri-rocket-2-line' },
  { to: '/painel/projetos-estrategicos', label: 'Projetos Estratégicos', icon: 'ri-focus-3-line' },
  { to: '/painel/licitacoes', label: 'Licitações', icon: 'ri-auction-line' },
  { to: '/painel/clientes', label: 'Clientes', icon: 'ri-building-4-line' },
  { to: '/painel/radar', label: 'Radar / Inteligência', icon: 'ri-radar-line' },
  { to: '/painel/resultados', label: 'Resultados', icon: 'ri-line-chart-line' },
  { to: '/painel/fornecedores', label: 'Fornecedores', icon: 'ri-store-3-line' },
  { to: '/painel/relacionamentos', label: 'Relacionamentos', icon: 'ri-heart-3-line' },
  { to: '/painel/configuracoes', label: 'Configurações', icon: 'ri-settings-3-line' },
];